import uniqueByCourseCode from './uniquebycoursecode.filter';
import dateTime from './datetime.filter';
import program from './program.filter';
import pattern from './pattern.filter';
import paging from './paging.filter';
import sentenceCase from './sentencecase.filter';
import day from './day.filter';
import location from './location.filter';
import type from './type.filter';
import time from './time.filter';

const moduleName = 'usc.timetable.filters';

angular.module(moduleName, [])
    .filter('uniqueByCourseCode', uniqueByCourseCode)
    .filter('dateTime', dateTime)
    .filter('program', program)
    .filter('pattern', pattern)
    .filter('paging', paging)
    .filter('sentenceCase', sentenceCase)
    .filter('day', ['timetableService', day])
    .filter('location', ['timetableService', location])
    .filter('type', ['timetableService', type])
    .filter('time', ['timetableService', time]);

export default moduleName;